// extracted by mini-css-extract-plugin
module.exports = {"designerPage":"DesignerPage_designerPage__3EMaQ","bkGray":"DesignerPage_bkGray__1eFrE"};